import React from "react";

import { CoffeIcon } from "./icons";
import { Container, ContainerColumn, Subtitle, Title } from "./styled";

interface ResourceViewerEmptyStateProps {
  title: string;
  subtitle: string;
}

export const ResourceViewerEmptyState = (props: ResourceViewerEmptyStateProps) => {
  const { title, subtitle } = props;

  return (
    <Container>
      <ContainerColumn>
        <CoffeIcon width="250px" height="200px" />

        <Title>{title}</Title>

        <Subtitle>{subtitle}</Subtitle>
      </ContainerColumn>
    </Container>
  );
};
